// import logo from './logo.svg';
import './App.css';
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './pages/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProductDetail from './pages/ProductDetail';
import { useState } from 'react';
import Cart from './pages/Cart';

function App() {
  const [cartItem, setcartItem] = useState([]);
  return (
    <div className="App">
      <Router>
        <Header cartItem={cartItem}/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product/:sku" element={<ProductDetail cartItem={cartItem} setcartItem={setcartItem} />} />
          <Route path="/cart" element={<Cart cartItem={cartItem} setcartItem={setcartItem} />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
